import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageData: {},
  pageFlag: 'create'
}

export const shareKeySlice = createSlice({
  name: 'shareKey',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setShareKeyDataAction: (state, action) => {
      state.pageData = action.payload
    },
    setShareKeyPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setShareKeyDataAction, setShareKeyPageFlagAction } = shareKeySlice.actions

// Selectors
export const selectShareKeyData = (state) => state.shareKey.pageData
export const selectShareKeyPageFlag = (state) => state.shareKey.pageFlag

// Reducer
export default shareKeySlice.reducer